"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseSearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return BaseSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _base = require("../../base");
const _enums = require("./enums");
const BaseSearchServiceQueryParams = _base.BaseQueryParams.extend({
    service: _enums.SearchServicesUnion,
    debug: _zod.z.boolean().optional()
});
